// $(".bulk-atc-btn").click(function(){
//     var all_datas = [];
//     $(".bulk-add-to-cart").find("tr").each(function(){
//         $(this).find("td").each(function(){
//             var variant_id = $(this).find(".bulk-qty").attr("data-vid");
//             var qty = $(this).find(".bulk-qty").val();
            
//             if(parseInt(qty)>0){
//                 console.log(variant_id);
//                 console.log(qty);
//                 var all_data = variant_id+":"+qty;
               
//                  all_datas.push(all_data);
                
//             }   
       
            
//         });
//     });
// console.log(all_datas);  
// });

// for adding the items to the cart

$(document).on("click",".bulk-atc-btn",function(){ 
//    var variant_id="";
//   var qty="";
      //   console.log(variant_id);
  
  var all_datas = [];
  Shopify.queue = [];
    $(".bulk-add-to-cart-test").find("tr").each(function(){
        $(this).find("td").each(function(){
             var variant_id = $(this).find(".bulk-qty").attr("data-vid");
          var availability = $(this).find(".bulk-qty").attr("data-var-availability");
          console.log();
             var qty = $(this).find(".bulk-qty").val();
          if (availability){
            if(parseInt(qty)>0){
                Shopify.queue.push( {
              variantId: variant_id,
              quantity: qty
            }); 

              Shopify.addItem = function(id, qty, callback) {
                var params = {
                  quantity: qty,
                  id: id
                };
                jQuery.ajax({
                  url: '/cart/add.js',
                  dataType: 'json',
                  type: 'post',
                  data: params,
                  success: function(individual_item){
                    if(typeof callback === 'function'){
                      callback();
                    }             
                  }
                });

              }
                
            } 
          }else{
//           	var error_for_qty = '<p>The 
          }
            
        });
    });
 
      Shopify.moveAlong = function() {
        // If we still have requests in the queue, let's process the next one.
        if (Shopify.queue.length) {
          var request = Shopify.queue.shift();
          Shopify.addItem(request.variantId, request.quantity, Shopify.moveAlong);
        }
        // If the queue is empty, this will redirect to the cart page.
        else {
          document.location.href = '/cart';
        }
      };

      Shopify.moveAlong();
    });